import styled, { css, keyframes, injectGlobal, withTheme, } from 'styled-components';
import ThemeProvider from './ThemeProvider';
import useTheme from './useTheme';
var newStyled = styled;
var newCss = css;
var newKeyframs = keyframes;
var newInjectGlobal = injectGlobal;
var newWithTheme = withTheme;
function withProps() {
    return function (fn) {
        return fn;
    };
}
export default newStyled;
export { newCss as css, newInjectGlobal as injectGlobal, newKeyframs as keyframes, ThemeProvider, newWithTheme as withTheme, withProps, useTheme, };
//# sourceMappingURL=index.js.map